import styled from 'styled-components'
import DefaultInput from '../../dumbs/Input'
import Typography from '../../dumbs/Typography'
import { LabelProps, WrapperProps } from './interfaces'

export const Input = styled(DefaultInput)``

export const BottomText = styled(Typography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  margin-top: ${({ theme }) => theme.spacing.km1};
`

export const Error = styled(BottomText)`
  color: ${({ theme }) => theme.danger.text.default};
  margin-top: ${({ theme }) => theme.spacing.km1};
`

export const Label = styled(Typography).attrs({ as: 'label' })<LabelProps>`
  color: ${({ theme, $status }) => $status && theme[$status].text.strong};
`

export const Message = styled(BottomText)`
  color: ${({ theme }) => theme.neutral.text.default};
`

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing.km1};

  & > input,
  & > input:focus {
    border-color: ${({ theme, $status }) => $status && theme[$status].border.default};
  }

  input:not(:last-child) {
    padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km10}
      ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km3};
  }

  & > svg {
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translate(calc(-100% - ${({ theme }) => theme.spacing.km3}), -50%);
  }

  &
    > input:not(:focus)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #7b829d;
    }
  }

  &
    > input:not(:placeholder-shown)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #232b43;
    }
  }
`
